import { useState } from 'react';
import Layout from '../../../components/feature/Layout';

export default function NewOperation() {
  const [currentStep, setCurrentStep] = useState(1);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const steps = [
    { number: 1, title: 'Datos Base', icon: 'ri-file-text-line' },
    { number: 2, title: 'Referencias', icon: 'ri-bookmark-line' },
    { number: 3, title: 'Fechas Críticas', icon: 'ri-calendar-line' },
    { number: 4, title: 'Asignación', icon: 'ri-user-line' },
    { number: 5, title: 'Documentos', icon: 'ri-folder-line' },
  ];

  const handleSubmit = () => {
    setShowSuccessModal(true);
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-[#0A2A43]">Nueva Operación Aduanera</h1>
          <p className="text-sm text-[#6B7280] mt-1">Crea una nueva operación de comercio exterior paso a paso</p>
        </div>

        {/* Wizard Steps */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-8">
            {steps.map((step, index) => (
              <div key={step.number} className="flex items-center flex-1">
                <div className="flex flex-col items-center flex-1">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                    currentStep >= step.number
                      ? 'bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white'
                      : 'bg-gray-100 text-[#6B7280]'
                  }`}>
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  <span className={`text-xs font-medium mt-2 ${
                    currentStep >= step.number ? 'text-[#0A2A43]' : 'text-[#6B7280]'
                  }`}>
                    {step.title}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div className={`h-0.5 flex-1 mx-2 transition-all ${
                    currentStep > step.number ? 'bg-[#2F80ED]' : 'bg-gray-200'
                  }`}></div>
                )}
              </div>
            ))}
          </div>

          {/* Step 1: Datos Base */}
          {currentStep === 1 && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold text-[#0A2A43]">Información Base de la Operación</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Cliente *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Seleccionar cliente...</option>
                    <option>Importadora Global S.A.</option>
                    <option>Exportadora del Sur Ltda.</option>
                    <option>Comercial Andina S.A.C.</option>
                    <option>Distribuidora Pacífico E.I.R.L.</option>
                    <option>Logística Internacional Corp.</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Operación *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Importación</option>
                    <option>Exportación</option>
                    <option>Reexportación</option>
                    <option>Tránsito Internacional</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Aduana/Frontera *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Aduana del Callao</option>
                    <option>Aduana Marítima del Callao</option>
                    <option>Aduana Aérea Jorge Chávez</option>
                    <option>Aduana de Paita</option>
                    <option>Aduana de Mollendo</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">País Origen *</label>
                  <input type="text" placeholder="Ej: China" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">País Destino *</label>
                  <input type="text" placeholder="Ej: Perú" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Incoterm *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>FOB - Free On Board</option>
                    <option>CIF - Cost, Insurance and Freight</option>
                    <option>EXW - Ex Works</option>
                    <option>DDP - Delivered Duty Paid</option>
                    <option>FCA - Free Carrier</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Medio de Transporte *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Marítimo</option>
                    <option>Aéreo</option>
                    <option>Terrestre</option>
                    <option>Multimodal</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Ruta</label>
                  <input type="text" placeholder="Ej: Shanghai - Callao" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
            </div>
          )}

          {/* Step 2: Referencias */}
          {currentStep === 2 && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold text-[#0A2A43]">Referencias y Documentos de Transporte</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">BL / AWB *</label>
                  <input type="text" placeholder="Número de conocimiento de embarque" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Número de Factura *</label>
                  <input type="text" placeholder="INV-2024-0001" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Número de Contenedor</label>
                  <input type="text" placeholder="MSCU1234567" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Contenedor</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>20' Standard</option>
                    <option>40' Standard</option>
                    <option>40' High Cube</option>
                    <option>20' Refrigerado</option>
                    <option>40' Refrigerado</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Placas / Vehículo</label>
                  <input type="text" placeholder="ABC-123" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nombre del Piloto</label>
                  <input type="text" placeholder="Nombre completo" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Descripción de Mercancía *</label>
                <textarea rows={4} placeholder="Descripción detallada de la mercancía..." className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"></textarea>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fracción Arancelaria</label>
                  <input type="text" placeholder="8471.30.01" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Peso Bruto (kg)</label>
                  <input type="number" placeholder="0.00" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Valor FOB (USD)</label>
                  <input type="number" placeholder="0.00" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
            </div>
          )}

          {/* Step 3: Fechas Críticas */}
          {currentStep === 3 && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold text-[#0A2A43]">Fechas Críticas de la Operación</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">ETA (Estimated Time of Arrival) *</label>
                  <input type="date" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fecha de Zarpe</label>
                  <input type="date" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Estimada de Despacho</label>
                  <input type="date" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Estimada de Entrega</label>
                  <input type="date" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Límite Documentación</label>
                  <input type="date" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fecha Vencimiento Almacenaje</label>
                  <input type="date" className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
                </div>
              </div>
              <div className="bg-[#EAF2F8] border border-[#2F80ED]/20 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-[#2F80ED] text-xl mt-0.5"></i>
                  <div>
                    <p className="text-sm font-medium text-[#0A2A43]">Recordatorio de Fechas Críticas</p>
                    <p className="text-xs text-[#6B7280] mt-1">El sistema enviará notificaciones automáticas 48 horas antes de cada fecha crítica al gestor responsable y al cliente.</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 4: Asignación */}
          {currentStep === 4 && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold text-[#0A2A43]">Asignación y Prioridad</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Gestor Responsable *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Juan Delgado - Gerente Operaciones</option>
                    <option>María González - Coordinadora Aduanas</option>
                    <option>Carlos Ramírez - Especialista Importaciones</option>
                    <option>Ana Torres - Especialista Exportaciones</option>
                    <option>Luis Mendoza - Gestor Senior</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Prioridad *</label>
                  <select className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                    <option>Normal</option>
                    <option>Alta</option>
                    <option>Urgente</option>
                    <option>Crítica</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Equipo de Soporte (opcional)</label>
                <div className="space-y-2">
                  <label className="flex items-center gap-2 p-3 border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer">
                    <input type="checkbox" className="rounded border-gray-300" />
                    <span className="text-sm text-gray-700">Pedro Sánchez - Documentación</span>
                  </label>
                  <label className="flex items-center gap-2 p-3 border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer">
                    <input type="checkbox" className="rounded border-gray-300" />
                    <span className="text-sm text-gray-700">Laura Martínez - Logística</span>
                  </label>
                  <label className="flex items-center gap-2 p-3 border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer">
                    <input type="checkbox" className="rounded border-gray-300" />
                    <span className="text-sm text-gray-700">Roberto Díaz - Finanzas</span>
                  </label>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Notas Internas</label>
                <textarea rows={4} placeholder="Notas o instrucciones especiales para el equipo..." className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]"></textarea>
              </div>
            </div>
          )}

          {/* Step 5: Documentos */}
          {currentStep === 5 && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold text-[#0A2A43]">Documentos Iniciales</h3>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-[#2F80ED] transition-colors cursor-pointer">
                <i className="ri-upload-cloud-line text-5xl text-[#6B7280] mb-3"></i>
                <p className="text-sm font-medium text-[#0A2A43] mb-1">Arrastra archivos aquí o haz clic para seleccionar</p>
                <p className="text-xs text-[#6B7280]">PDF, JPG, PNG, Excel hasta 10MB por archivo</p>
              </div>
              <div className="space-y-3">
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#EF4444]/10 flex items-center justify-center">
                      <i className="ri-file-pdf-line text-xl text-[#EF4444]"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-[#0A2A43]">Factura_Comercial_2024.pdf</p>
                      <p className="text-xs text-[#6B7280]">2.4 MB</p>
                    </div>
                  </div>
                  <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-white cursor-pointer">
                    <i className="ri-close-line text-lg text-[#6B7280]"></i>
                  </button>
                </div>
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-[#10B981]/10 flex items-center justify-center">
                      <i className="ri-file-excel-line text-xl text-[#10B981]"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-[#0A2A43]">Packing_List.xlsx</p>
                      <p className="text-xs text-[#6B7280]">1.8 MB</p>
                    </div>
                  </div>
                  <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-white cursor-pointer">
                    <i className="ri-close-line text-lg text-[#6B7280]"></i>
                  </button>
                </div>
              </div>
              <div className="bg-[#EAF2F8] border border-[#2F80ED]/20 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <i className="ri-lightbulb-line text-[#2F80ED] text-xl mt-0.5"></i>
                  <div>
                    <p className="text-sm font-medium text-[#0A2A43]">Documentos Recomendados</p>
                    <ul className="text-xs text-[#6B7280] mt-2 space-y-1">
                      <li>• Factura Comercial</li>
                      <li>• Packing List</li>
                      <li>• Bill of Lading (BL) o Air Waybill (AWB)</li>
                      <li>• Certificado de Origen (si aplica)</li>
                      <li>• Permisos especiales (si aplica)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-200">
            <button
              onClick={() => setCurrentStep(Math.max(1, currentStep - 1))}
              disabled={currentStep === 1}
              className={`px-6 py-2.5 border border-gray-200 rounded-md font-medium transition-all whitespace-nowrap ${
                currentStep === 1
                  ? 'text-gray-400 cursor-not-allowed'
                  : 'text-[#6B7280] hover:bg-gray-50 cursor-pointer'
              }`}
            >
              <i className="ri-arrow-left-line mr-2"></i>Anterior
            </button>
            <div className="flex items-center gap-2">
              {steps.map((step) => (
                <div
                  key={step.number}
                  className={`w-2 h-2 rounded-full transition-all ${
                    currentStep >= step.number ? 'bg-[#2F80ED]' : 'bg-gray-300'
                  }`}
                ></div>
              ))}
            </div>
            {currentStep < 5 ? (
              <button
                onClick={() => setCurrentStep(Math.min(5, currentStep + 1))}
                className="px-6 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md font-medium hover:shadow-md transition-all cursor-pointer whitespace-nowrap"
              >
                Siguiente<i className="ri-arrow-right-line ml-2"></i>
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className="px-6 py-2.5 bg-gradient-to-r from-[#10B981] to-[#059669] text-white rounded-md font-medium hover:shadow-md transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-check-line mr-2"></i>Crear Operación
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-md mx-4">
            <div className="p-8 text-center">
              <div className="w-16 h-16 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-4xl text-[#10B981]"></i>
              </div>
              <h2 className="text-2xl font-bold text-[#0A2A43] mb-2">¡Operación Creada!</h2>
              <p className="text-sm text-[#6B7280] mb-6">La operación <strong>OP-2024-1849</strong> ha sido creada exitosamente y asignada al gestor responsable.</p>
              <div className="flex gap-3">
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/operations')}
                  className="flex-1 px-4 py-2.5 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap"
                >
                  Ver Bandeja
                </button>
                <button
                  onClick={() => {
                    setShowSuccessModal(false);
                    setCurrentStep(1);
                  }}
                  className="flex-1 px-4 py-2.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap"
                >
                  Crear Otra
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
